import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  filter_select: {
    ['.MuiSelect-select']: {
      minWidth: '130px',
    },
    [`> svg`]: {
      marginRight: '4px',
    },
    ['.MuiInputLabel-root']: {
      zIndex: 1,
      backgroundColor: theme.palette.background.paper,
      paddingLeft: '4px',
      paddingRight: '4px',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -9px) scale(0.75)',
        transformOrigin: 'top left',
        backgroundColor: theme.palette.background.paper,
      },
    },
    ['.MuiOutlinedInput-notchedOutline']: {
      '& legend': {
        maxWidth: '0.01px',
        '& span': {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
    },
    '&.Mui-focused .MuiInputLabel-root': {
      transform: 'translate(14px, -9px) scale(0.75)',
      backgroundColor: theme.palette.background.paper,
    },
  },
}));
